/** ------------------------------------------------------------------------- *
 * Sticky Nav Styling *
 * -------------------------------------------------------------------------- *
 * @module StickyNav
 * @desc
 * Adds a class to the page header element once the page has scrolled past the
 * target element. The target element is typically found at the top of the
 * page, but the minimum amount of scrolling required before triggering the
 * script can be adjusted using the rootMargin setting.
 */

const settings = {
    selectors: {
        // The header element to stick on scroll
        header: '#js-header',
        // The element to use as a scroll target
        target: '#js-header-sentinel',
    },
    // The class to be added to the header element once scrolled
    state_class: 'is-scrolled',
    // Options for the intersection observer
    observer: {
        // null = document root
        root: null,
        // Extend the bounding box of the element by X to delay intersecting
        rootMargin: '100px',
        // 0 = the element is not in view
        threshold: 0,
    },
};

let header_el;

function callback(entries) {
    entries.forEach((entry) => {
        // Toggle class based on scroll position
        if (entry.isIntersecting === false) {
            header_el.classList.add(settings.state_class);
        } else {
            header_el.classList.remove(settings.state_class);
        }
    });
}

/** ------------ *
 * Module Export *
 * ------------- *
 */

const StickyNav = {
    /**
     * @property StickyNav.init
     * @method
     * @desc Intiializes the module
     */

    init() {
        const target_el = document.querySelector(settings.selectors.target);
        header_el = document.querySelector(settings.selectors.header);

        // Begin observing scroll
        const observer = new IntersectionObserver(callback, settings.observer);
        observer.observe(target_el);
    },
};

export default StickyNav;
